export const SET_USER_AUTH = "SET_USER_AUTH";
export const SET_USER_LOGGING = "SET_USER_LOGGING";
export const SET_USER_DATA = "SET_USER_DATA";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_USER_DOCUMENTS = "UPDATE_USER_DOCUMENTS";
export const UPDATE_USER_PROFILE_LOOKING_FOR = "UPDATE_USER_PROFILE_LOOKING_FOR";
export const UPDATE_USER_PROFILE_YACHT = "UPDATE_USER_PROFILE_YACHT";